import { FC, MouseEventHandler } from 'react'

import { Title, Text, Button, Icon } from '../../'

type FormMessageAcceptRejectProps = {
  className?: string,
  title?: string,
  message?: string,
  buttonAcceptText?: string,
  buttonRejectText?: string,
  onAcceptClick: MouseEventHandler<HTMLButtonElement>,
  onRejectClick: MouseEventHandler<HTMLButtonElement>
}

const FormMessageAcceptReject:FC<FormMessageAcceptRejectProps> = ({ className = '', children, title = 'Información importante', buttonAcceptText = 'Aceptar', buttonRejectText = 'Rechazar', onAcceptClick, onRejectClick })  => {
  return (
    <div className={`text-center ${className}`}>
      <Icon name="alert" />
      <Title component="h4" size="20" weight="bold" className="mt-20">{title}</Title>
      <Text size="14" lineHeight="6" className="mt-20">{children}</Text>

      <div className="mt-30">
        <Button color="primary" onClick={onAcceptClick}>{buttonAcceptText}</Button>
        <Button onClick={onRejectClick} className="ml-20">{buttonRejectText}</Button>
      </div>
    </div>
  )
}

export { FormMessageAcceptReject }